import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["grid", "button", "buttonContainer"]
    static values = {
        url: String,
        page: Number,
        hasMore: Boolean,
        loading: Boolean
    }

    async loadMore() {
        if (this.loadingValue || !this.hasMoreValue) return

        this.loadingValue = true
        this.buttonTarget.disabled = true
        this.buttonTarget.classList.add("opacity-60")

        const url = new URL(this.urlValue, window.location.origin)
        url.searchParams.set("page", this.pageValue + 1)

        try {
            const response = await fetch(url, {
                headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" }
            })
            if (!response.ok) throw new Error(`Request failed: ${response.status}`)

            const data = await response.json()

            if (data.html) {
                this.gridTarget.insertAdjacentHTML("beforeend", data.html)
                this.pageValue += 1
            }

            this.hasMoreValue = data.has_more

            if (!data.has_more && this.hasButtonContainerTarget) {
                this.buttonContainerTarget.remove()
            }
        } catch (error) {
            console.error("Error loading more articles:", error)
        } finally {
            this.loadingValue = false
            if (this.hasMoreValue && this.hasButtonTarget) {
                this.buttonTarget.disabled = false
                this.buttonTarget.classList.remove("opacity-60")
            }
        }
    }
}
